module.exports = "<div class=\"kan-notes-list\">\n    <!--<div class=\"kan-spinner-container\"-->\n         <!--*ngIf=\"loading\">-->\n        <!--<mat-spinner color=\"primary\"></mat-spinner>-->\n    <!--</div>-->\n    <kan-notes-list-item *ngFor=\"let note of notes\"\n                           [note]=\"note\"\n                           [searchText]=\"searchText\"\n                           (refresh)=\"emitRefresh()\">\n    </kan-notes-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/notes/list/component.html
// module id = ./src/modules/admin/components/notes/list/component.html
// module chunks = main